export const CAMPAIGN_REACH = ['Domestic', 'International']
export const TAB_TYPE = ['Release', 'Playlist', 'Other']

export const DEFAULT_SORT_DIRECTION = 'DESC'
export const DEFAULT_SORT_FIELD = 'created_at';

export const SORT_FIELD_PARAM = 'sortBy'
export const SORT_DIRECTION = 'sortDirection'
export const PAGE_PARAM = 'page'
export const SEARCH_TERM_PARAM = 'term'

export * from './graphql'
